import React from 'react';
import { Link } from 'react-router-dom';
import {Trees, Facebook, Instagram} from 'lucide-react';

export default function Footer() {
  return (
    <footer className="text-gray-400 py-12 border-t border-gray-800 bg-[#111827]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6">
          <div className="flex flex-col items-center gap-1">
            <img
              src="https://static.lumi.new/0d/0dfebb2e7ed7f3a6844f66265e0a790e.webp"
              alt="Pinhacorada Logo"
              className="h-12 w-auto brightness-0 invert opacity-40" />
            <span className="text-sm font-bold text-[#94A3B8]">PINHACORADA</span>
          </div>
          
          <div className="text-sm">
            &copy; {new Date().getFullYear()} Pinhacorada. Todos os direitos reservados.
          </div>

          <div className="flex items-center gap-6">
            <div className="flex gap-4">
              <a href="https://www.facebook.com/pinhacorada" target="_blank" rel="noopener noreferrer" className="p-2 rounded-full bg-white/10 hover:bg-white/20 transition-all transform hover:scale-110">
                <Facebook className="h-5 w-5 text-white" />
              </a>
              <a href="https://www.instagram.com/pinhacorada" target="_blank" rel="noopener noreferrer" className="p-2 rounded-full bg-white/10 hover:bg-white/20 transition-all transform hover:scale-110">
                <Instagram className="h-5 w-5 text-white" />
              </a>
            </div>
          </div>
        </div>
        
        <div className="mt-8 pt-6 border-t border-gray-700 text-center">
          <div className="flex flex-wrap justify-center items-center gap-x-6 gap-y-3 text-sm">
            <Link to="/politica-privacidade" className="hover:text-white transition-colors whitespace-nowrap shrink-0">
              Política de Privacidade
            </Link>
            <span className="text-gray-600 hidden sm:inline shrink-0">|</span>
            <Link to="/politica-cookies" className="hover:text-white transition-colors whitespace-nowrap shrink-0">
              Política de Cookies
            </Link>
            <span className="text-gray-600 hidden sm:inline shrink-0">|</span>
            <Link to="/termos-servico" className="hover:text-white transition-colors whitespace-nowrap shrink-0">
              Termos de Serviço
            </Link>
            <span className="text-gray-600 hidden sm:inline shrink-0">|</span>
            <a 
              href="https://www.livroreclamacoes.pt/Inicio/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="hover:text-white transition-colors flex items-center gap-1 whitespace-nowrap shrink-0"
            >
              <span aria-hidden="true">📋</span>
              <span>Livro de Reclamações</span>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}